import { Component, Output, EventEmitter, ViewChild, ChangeDetectorRef, HostListener, Injector } from '@angular/core';
import { Subscription } from 'rxjs';
import { TabDataService } from '../../services/tab-data.service';
import {  TabView } from 'primeng/tabview';
import { TextValueLabel } from '../../model/Common/TextValueLabel';
import { InboxService } from '../../services/inbox.service';
import * as Rx from "rxjs";
import { ConfirmationService, SelectItem } from 'primeng/api';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { LeftNavigationService } from '../../core/leftnav/leftnav.service';
import { QmaConstant } from '../../constant/qma-constant';
import { GridOperationService } from "../../services/mailbox/grid-operation.service";
import { PersonalEmailService } from '../../personal-email/personal-email.service';
import { UserDataService } from '../../services/user-data.service';
import { PiwikProUtils } from '../../common/utility/piwikProUtils';
import { CoreComponent } from '../core.component';

interface SelectItemBlue extends SelectItem {
  icon_blue?: string;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  providers: [ConfirmationService],
  /* host: {
    '(document:keydown)': 'onKeyDown($event)'
  }, */
})
export class TabsComponent {
  static readonly SEARCH_ELIGIBLE_TABS = ["Inbox", "Sent", "Resolved"];
  static readonly NEW_MESSAGE_COMPONENTS = ["NEW MESSAGE", QmaConstant.QMA_NEW_BUBBLE, "Reply", "Forward", "ReplyAll", "ReplyResolve", "ReplyAllResolve", "DRAFT"];
  static readonly TAB_TEXT = ["NEW MESSAGE", QmaConstant.QMA_NEW_BUBBLE, "Reply", "Forward", "ReplyAll", "ReplyResolve", "ReplyAllResolve", "SEARCH", "DASHBOARD", "Sent", "INQUIRY:", "CHAT:"];
  static readonly DRAGDROP_ENABLED = ["NEW MESSAGE", QmaConstant.QMA_NEW_BUBBLE, "Reply", "Forward", "ReplyAll", "ReplyResolve", "ReplyAllResolve", "INQUIRY:", "CHAT:"];
  selectedTabIndex: number;
  public items: TextValueLabel[];
  subscription: Subscription;
  unreadSubscription: Subscription;
  MAX_CHAR: number = 3;
  @ViewChild('tabs', { static: true }) tabs: TabView;
  triggeredFromMessage: boolean = false;
  tabName: any;
  headerStyle: any = "header-class";
  selectedHeaderName: string;
  lastSelectedHeaderName: string;
  indexMatch = {
    NONE: 0,
    EXACT: 1,
    ELIGIBLE: 2,
    REPLACE: 3
  };
  @Output() searchClr = new EventEmitter<boolean>();
  currentInquiries: any = [];
  innerWidth: number;
  innerHeight: number;
  borderHighlight = false;
  isMobile: boolean = false;
  sidePanelOpen:boolean=false;
  activeTab: String = '';
  selectedReportTab = 'Report Criteria';
  inqReportTypes = QmaConstant.QMA_REPORT_TYPES;
  powerbiReportDetails = [];

  public inMobileSearch: boolean = false;
  dashboardCountSubs$: Subscription;
  tabDataSubscription: Subscription;
  tabNameforChatViewSymphony: string = "";

  tabDataDrawerSubscription: Subscription;
  isDrawerOpen: boolean = false;
  reportTabs = ['', 'Report Criteria']
  reportConfig = null;
  selectedReportType: string = '';

  updateArray(arr, obj) {
    return arr.map((item, index) => {
      // Add value property to the object where text matches the header
      if (item.text === obj.header) {
        return { ...item, value: obj.count };
      }
      return item;
    });
  }

  viewOptions: SelectItemBlue[];
  selectedView: any;
  mailBoxView: string = 'vertical';
  dropdownClicked: boolean = false;
  isOpen: boolean = false;


  constructor(
    private userDataService: UserDataService,
    public tabDataService: TabDataService, private inboxService: InboxService, private confirmationService: ConfirmationService,
    private dashboardService: DashboardService, private leftNavigationService: LeftNavigationService,
    private cdr: ChangeDetectorRef, private gridOprService: GridOperationService, private personalEmailService: PersonalEmailService,
    private injector: Injector
  ) { //C153176-5107, //C153176-4796: refactoring from mobile inbox view and enable change detection
    this.isMobile = window.innerWidth <= QmaConstant.MOBILE_WIDTH;
    this.items = this.isMobile ? [] : [{ text: 'DASHBOARD', value: '' }];

    this.subscription = this.tabDataService.getTabData().subscribe(tabData => {
      const prevTab = sessionStorage.getItem("currentTab");
      //reset tab header if it is Mobile version so as to use the same tab
      if (this.isMobile && tabData.header === "SEARCH" && this.selectedTabIndex != -1 && this.selectedHeaderName) {
        tabData.header = this.selectedHeaderName;
      }
      //refactor mobile action footer here
      this.tabDataService.footerMailboxArray.forEach(val => {
        val.isActiveTab = (val.label.toUpperCase() == tabData.header.toUpperCase());
      })
      this.triggeredFromMessage = (tabData.triggeredFrom === 'leftNav');
      const updateEligibleViewOnly = (tabData.triggeredFrom === 'updateEligibleViewOnly');
      this.tabName = tabData.header;
      if (this.tabName.startsWith('INQUIRY:') || this.tabName.startsWith('CHAT:')) {
          if (this.tabDataService.currentInquiry) {
            this.currentInquiries[tabData.header] = this.tabDataService.currentInquiry;
            if(this.currentInquiries[tabData.header]){ // add null check before accessing property
              this.currentInquiries[tabData.header].mailContainerHeight = Math.max(200, this.innerHeight - 30);
            }
            // reset the tabDataService's current inquiry
            delete this.tabDataService.currentInquiry;
          } else if (!this.currentInquiries[tabData.header]) {
              // if tab is selected but data wasn't loaded/cached yet
          }
      }

      sessionStorage.setItem("currentTab", tabData.header);
      const matchResult = this.checkSearchEligiblePanel(tabData.header);
      if (matchResult === this.indexMatch.NONE) {
        if (updateEligibleViewOnly) {
          //skip opening new tab, no eligible view to update, nor to open any new one.
          return;
        }

        //TO fix initial load issue
        if (this.tabs.tabs) {
          this.tabs.tabs.forEach(tab => {
            tab.selected = false;
          });
        }

        if (tabData.newTab){
          const existingIndex = this.items.findIndex(item => item.text === tabData.header);
          if (existingIndex !== -1) {
            this.items.splice(existingIndex, 1);
            const existingReport = this.powerbiReportDetails.findIndex(p => p.key === tabData.header);
            if (existingReport !== -1) {
              this.powerbiReportDetails.splice(existingReport, 1);
            }
          }
          this.items.push(new TextValueLabel(tabData.header, tabData.count, tabData.symphonyData));
          if (tabData.symphonyData?.reportConfig) {
            this.powerbiReportDetails.push({
              key: tabData.header,
              value: tabData.symphonyData.reportConfig,
              eventHandlers: tabData.symphonyData.eventHandlers ?? null
            });
            // Hide inbox chrome immediately; handleChange only fires on manual tab clicks.
            this.tabDataService.setMessageMenuToggleFalse();
          }
        }
        else{

          if (prevTab === 'DASHBOARD') {
            this.items.push(new TextValueLabel(tabData.header, tabData.count, tabData.symphonyData));
          } else {
            this.removeItemByHeader(prevTab);
            this.items.push(new TextValueLabel(tabData.header, tabData.count, tabData.symphonyData));
          }
        }

        this.dashboardCountSubs$ = this.dashboardService.getDashboardCountsServiceSubject()
        .pipe(
             Rx.distinctUntilChanged((prev, curr) => JSON.stringify(prev?.boxCounts) === JSON.stringify(curr?.boxCounts))
        )
        .subscribe(dashSnapshotCnts => {
            if (dashSnapshotCnts && dashSnapshotCnts.boxCounts) {
                let changed = false;
                dashSnapshotCnts.boxCounts.forEach((val: any) => {
                    const key = Object.keys(val)[0];
                    const newCount = val[key]?.unReadCount;

                    if (typeof newCount !== 'undefined') {
                        let t = this.items.find(item => item.text.toUpperCase() === key.toUpperCase());
                        if (t) {
                            if (t.value !== newCount) {
                                t.value = newCount;
                                changed = true;
                            }
                        }
                    }
                });
                if (changed) {
                    this.cdr.detectChanges();
                }
            }
        });

        this.selectedTabIndex = this.getIndex(this.items, tabData.header);
        //  save current selected header to lastSelectedHeaderName
        if(!tabData.newTab && prevTab !== 'DASHBOARD'){
        }
        else{
          this.lastSelectedHeaderName = this.selectedHeaderName;
        }
        this.selectedHeaderName = tabData.header;//
      } else {
        this.tabs.tabs.forEach(tab => {
          tab.selected = false;
        });
        if (matchResult == this.indexMatch.EXACT) {
          // exact match — mutate in place to keep *ngFor stable (avoids ASSERTION ERROR during rapid clicks)
          const matchedItem = this.items.find(i => i.text === tabData.header);
          if (matchedItem) { matchedItem.value = tabData.count; }
          // If a new reportConfig was supplied (e.g. re-click with new date range, or hyperlink
          // with updated rp:* params), update powerbiReportDetails so the embed reloads with the
          // fresh config. Replacing the array reference triggers Angular change detection.
          if (tabData.symphonyData?.reportConfig) {
            const idx = this.powerbiReportDetails.findIndex(p => p.key === tabData.header);
            if (idx !== -1) {
              this.powerbiReportDetails[idx] = { key: tabData.header, value: tabData.symphonyData.reportConfig };
            } else {
              this.powerbiReportDetails.push({ key: tabData.header, value: tabData.symphonyData.reportConfig });
            }
            this.powerbiReportDetails = [...this.powerbiReportDetails];
          }
          this.selectedTabIndex = this.getIndex(this.items, tabData.header);
          // save current selected header to lastSelectedHeaderName
          this.lastSelectedHeaderName = this.selectedHeaderName;
          this.selectedHeaderName = this.items[this.selectedTabIndex].text;
        } else if (matchResult == this.indexMatch.ELIGIBLE) {
          // search eligible panels
          this.selectedTabIndex = this.getSearchEligibleIndex(this.items, TabsComponent.SEARCH_ELIGIBLE_TABS, this.selectedTabIndex);
          //update 'currentTab' with the eligible tab's header, so that it points to the right tab
          sessionStorage.setItem("currentTab", this.items[this.selectedTabIndex].text);
          //save current selected header to lastSelectedHeaderName
          this.lastSelectedHeaderName = this.selectedHeaderName;
          this.selectedHeaderName = this.items[this.selectedTabIndex].text;
        } else if (matchResult == this.indexMatch.REPLACE) {
          this.selectedTabIndex = this.getReplacedIndex(tabData.header);
          //save current selected header to lastSelectedHeaderName
          this.lastSelectedHeaderName = this.selectedHeaderName;
          this.items[this.selectedTabIndex].text = tabData.header;
          this.selectedHeaderName = tabData.header;
        }
        if (this.tabs?.tabs?.[this.selectedTabIndex]) {
          this.tabs.tabs[this.selectedTabIndex].selected = true;
        }
        if (!updateEligibleViewOnly || matchResult === this.indexMatch.ELIGIBLE) {
          // if updateEligibleViewOnly is true, update only if the match result is ELIGIBLE;
          // in all other cases, proceed update (trigger data change).
          if (updateEligibleViewOnly || matchResult === this.indexMatch.ELIGIBLE) {
            // start loading spin here as this is the only place where it is certain there is a reload to be triggered
            this.inboxService.startViewLoading({ color: '#020e38' });
          }

          // This code should execute only when user perform global search and grid open from dashboard.
          if (this.tabName === 'SEARCH' || this.tabName === QmaConstant.QMA_OPEN_INQ_BYASSIGNEDGROUP ||
            this.tabName === QmaConstant.QMA_OPEN_INQ_BYREQUESTTYPE || this.tabName === QmaConstant.QMA_OPEN_INQ_BY_OWNER
            || this.tabName === QmaConstant.QMA_PERSONAL) {
            this.inboxService.triggerDataChange({ tabName: this.tabs.tabs[this.selectedTabIndex]?.header, dashboardInlineView: false });
          }
          // trigger search for mobile
          if (this.isMobile) {
            if (tabData.triggeredFrom == 'leftNav') {
              this.inboxService.triggerDataChange({ tabName: this.tabs.tabs[this.selectedTabIndex]?.header, dashboardInlineView: false });
            } else {
              /*  if ((this.tabName === 'Inbox')) { */
              this.inboxService.triggerDataChange({ tabName: this.tabs.tabs[this.selectedTabIndex]?.header, dashboardInlineView: false });
              /* } */
            }
          }
        }
      }
      //this.tabDataService.tabs = this.tabs; // PERFORAMCE IMPROVEMENT - Why is the need of this we are updating the tab-panels
      if (inboxService.requestObj && inboxService.requestObj.from) {
        this.inboxService.triggerSearchTabEvent({ index: this.selectedTabIndex, tab: this.selectedHeaderName, action: 'addUpdate' });
      } else {
        this.inboxService.triggerSearchTabEvent({ index: this.selectedTabIndex, tab: this.selectedHeaderName, action: 'clear' });
      }
    });
    // Layout option fromm UserProfile
    this.inboxService.getLayoutOption().subscribe(lo => {
      this.mailBoxView = lo.toLocaleLowerCase();
      this.selectedView = this.viewOptions?.find(option => option.value === this.mailBoxView);
    });

    // inquiry drag highlight handling
    this.inboxService.inquiryDragEvent.subscribe((evt: any) => {
      if (evt && evt.qma) {
        this.borderHighlight = evt.active;
      }
    });
    this.inboxService.mobileSearchEnabledEvent.subscribe(flag => {
      // entering / leaving search mode
      this.inMobileSearch = flag;
      this.cdr.detectChanges();
    });
    this.unreadSubscription = this.tabDataService.onUnReadCount().subscribe(tuple => {
      let name = tuple.name;
      let count = tuple.count;
      if (this.items && name && (count !== undefined)) {
        let index = this.items.findIndex(item => item.text && item.text.toUpperCase() === name.toUpperCase());
        if (index > -1) {
          this.items[index].value = count;
          this.cdr.detectChanges();
        }
      }
    });
  }
  removeItemByHeader(header: string) {
    this.items = this.items.filter(item => item.text !== header);
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.tabDataService.markTabComponentReady();

    this.dashboardService.getUpdatedUnreadCount().subscribe(data => {
      if (this.isObjetEmpty(data)) {
        return;
      }
      this.items.filter(i => i.text.toUpperCase() === data.tabName)[0].value = data.updatedUnread;
    });
    // close search tab on click of close icon of serch input
    this.tabDataService.getsubjectOnTabClose().subscribe((tabHeader: string) => {
      const index = this.tabs.tabs.findIndex(t => t.header === tabHeader)
      if (index > -1) {
        let event = { index: index, close: function () { } };
        this.performTabOperation(event, tabHeader);
      }

    });
    this.tabDataSubscription = this.tabDataService
    .getTabData()
    .subscribe((data) => {
      this.activeTab = data.header;
    });

    this.tabDataDrawerSubscription =    this.tabDataService.drawerStatusChanged.subscribe((isOpen: boolean) => {
      // console.log('drawerStatus', this.isDrawerOpen)
      this.isDrawerOpen = isOpen;
    });

    this.viewOptions = [
      {
        label: 'Vertical View',
        value: 'vertical',
        icon: 'assets/qwyn/icons/new_vertical_view.svg',
        icon_blue: 'assets/qwyn/icons/new_vertical_view.svg'
      },
      {
        label: 'Horizontal View',
        value: 'horizontal',
        icon: 'assets/qwyn/icons/new_horizontal_view.svg',
        icon_blue: 'assets/qwyn/icons/new_horizontal_view.svg'
      },
      {
        label: 'Chat View',
        value: 'chatview',
        icon: 'assets/qwyn/icons/new_chat_view.svg',
        icon_blue: 'assets/qwyn/icons/new_chat_view.svg',
      }
    ];

    this.selectedView = this.viewOptions.find(option => option.value === 'vertical');
  }

  /**
   * Method to change the view type of conversation
   */
  onImgClick(clickedIcon: string, tabName: string) {

    this.mailBoxView = tabName;

    if (tabName === 'chatview' && this.mailBoxView != tabName) {
      let requestObj = {
        action: "SWITCH TO CHAT VIEW",
        description: "Switch to chat view in " + clickedIcon
      };

      this.inboxService.userActivity(requestObj).subscribe(result => {
        if (result) {
          console.log('User activity is saved.', result);

          // Add the start time
          this.tabDataService.setChatViewUsageStatistics(clickedIcon);
        }
      }, error => {
        console.error('Failed to add user activity', error);
        // Add the start time
        this.tabDataService.setChatViewUsageStatistics(clickedIcon);
      });
    } else {
      // Update the time.
      this.tabDataService.updateChatViewUsageStatistics(clickedIcon);
    }

    this.tabDataService.setClickedIcon(tabName);
    this.mailBoxView = tabName;
    this.tabDataService.tabName = tabName;
  }
  openSidePanel(){
    this.sidePanelOpen=true;
    // this.tabDataService.setSidePanelOpen(true);
  }
  closeSidePanel(){
    this.sidePanelOpen=false;
  }

  onDropdownChange(event: any) {
    this.selectedView = event.value;
    this.mailBoxView = this.selectedView.value;
    // Call it with the necessary parameters.
    this.onImgClick('', this.mailBoxView);
  }

  onDropdownShow() {
    this.isOpen = true;
  }

  onDropdownHide() {
    this.isOpen = false;
  }

  /**
   * Check whether the specified tabName matches any of the existing tab header.
   * @param tabName tab header
   * @return:
   *  NONE (0): no match
   *  EXACT (1): exact match in header string
   *  ELIGIBLE (2): If the tabName is SEARCH, and one of the selected tabs is Inbox, Sent or Resolved.
   */
  checkSearchEligiblePanel(tabName: string): number {
    if (this.items.some(item => item.text === tabName)) {
      // exact match
      return this.indexMatch.EXACT;
    }
    // if (tabName && tabName.toUpperCase() === "SEARCH"
    //   && TabsComponent.SEARCH_ELIGIBLE_TABS.some((val) => this.items.some(item => item.text === val))
    //   && !this.isMultiBoxMatched()
    //   && this.getSearchEligibleIndex(this.items, TabsComponent.SEARCH_ELIGIBLE_TABS, this.selectedTabIndex) != -1) {
    //   // in case of SEARCH, at least one of the tables is Inbox, Sent, Resolved.
    //   return this.indexMatch.ELIGIBLE;
    // }
    else if (tabName && tabName.toUpperCase().startsWith('REPLY') &&
      this.items.some(item => item.text && item.text.toUpperCase().replace('ALL', '') === tabName.toUpperCase().replace('ALL', ''))) {
      return this.indexMatch.REPLACE;
    }
    // other cases (non-match)
    return this.indexMatch.NONE;
  }
  getIndex(data, value, upperCase?) {
    let index = -1;
    data.forEach((item, i) => {
      if (item.text === value || (upperCase && item.text.toUpperCase() === value.toUpperCase())) {
        index = i;
      }
    });
    return index;
  }
  /***
   * Search and return any eligible index.
   * Eligibility is defined as when the one of the items in 'data' appears in the 'values' collection, and it is the selected index,
   * and also, it is in the adv-search Search In boxes if it is present (selected by user)
   * @param data
   * @param values
   * @return the eligible index. If no such index is found, return -1.
   */
  getSearchEligibleIndex(data, values, selectedIndex) {
    let index = -1;
    data.forEach((item, i) => {
      if (values.includes(item.text) && selectedIndex === i &&
        (!this.inboxService.searchBoxes || !this.inboxService.searchBoxes.length ||
          this.inboxService.searchBoxes.includes(item.text))) {
        index = i;
      }
    });
    return index;
  }
  getReplacedIndex(tabName) {
    let index = -1;
    const normalizedName = tabName.toUpperCase().replace('ALL', '');
    this.items.forEach((item, i) => {
      if (item.text && item.text.toUpperCase().replace('ALL', '') === normalizedName) {
        index = i;
      }
    });
    return index;
  }
  handleChange(event: any) {
    this.gridOprService.clearConversationRequestData();
    // make the existing selected tab's property selected = false
    this.tabs.tabs.forEach(tab => {
      tab.selected = false;
    });
    this.selectedTabIndex = event.index;
    this.tabs.tabs[this.selectedTabIndex].selected = true;
    this.lastSelectedHeaderName = this.selectedHeaderName;
    this.selectedHeaderName = this.tabs.tabs[this.selectedTabIndex].header;//
    this.tabDataService.setTabChange(this.selectedHeaderName)
    sessionStorage.setItem("currentTab", this.selectedHeaderName);
    this.userDataService.userUsageStats("Dashboard", this.selectedHeaderName).subscribe(result => console.log("StartTime:" + new Date()));
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Tab", this.selectedHeaderName, "Click", this.selectedHeaderName, 0)
    this.coreComponent.activeTab = this.selectedHeaderName;
    const existingReport = this.powerbiReportDetails.find(
      (item) => item.key === this.selectedHeaderName
    );
    const currentItem = this.items.find(i => i.text === this.selectedHeaderName);
    const hasReportConfig = !!currentItem?.inputData?.reportConfig?.id
      || this.tabDataService.misReportTabNames.has(this.selectedHeaderName);
    
    if (this.isValidReportType(this.selectedHeaderName) || this.selectedHeaderName?.toLowerCase() === 'report criteria' || existingReport || hasReportConfig || this.selectedHeaderName === 'Management Report') {
      this.reportConfig = existingReport?.value ?? this.reportConfig;
      this.tabDataService.setMessageMenuToggleFalse();
    }
    else {
      this.tabDataService.setMessageMenuToggleTrue();
    }
    // this.tabDataService.sendTabData(this.selectedHeaderName, this.items[this.selectedTabIndex].value, 'tabChange'); // -- Commented out since it makes multiple api calls when we switch between tabs
  }
  handleReportTabChange(event: any) {
    this.selectedReportTab = this.reportTabs[event.index];
   }
  checkForOtherTabs(items: any[]) {
    // Check if there are any tabs besides "DASHBOARD" or "GROUPADMIN"
    const hasOtherTabs = items.some(item => {
      const text = item.text.toUpperCase();
      return text !== 'DASHBOARD' && text !== 'GROUPADMIN';
    });
    if (!hasOtherTabs) {
      // No tabs other than Dashboard or GroupAdmin found
      this.tabDataService.sendTabData("DASHBOARD", 0);
    } else {
      // Other Tabs found
    }
  }

  redirectCheck() {
    if (this.items.length === 1) { // if there are no other tabs
      this.tabDataService.sendTabData("DASHBOARD", 0);
    } else {
      setTimeout(() => {
        this.checkForOtherTabs(this.items);
      }, 1)
    }
  }

  handleClose(event: any) {
    let locallySetTab = sessionStorage.getItem("currentTab");
    const closedHeaderName = this.tabs.tabs[event.index].header;

    /** QMA-1320 **/
    const tabsList = this.tabs.tabs;

    // find the index of the closed tab
    const closedIndex = tabsList.findIndex(tab => tab.header === closedHeaderName);

    // look for the next valid tab (not DASHBOARD or GROUPADMIN)
    let nextValidTab = null;

    // first try to get the next tab after the closed one
    for (let i = closedIndex + 1; i < tabsList.length; i++) {
        if (tabsList[i].header !== 'DASHBOARD' && tabsList[i].header !== 'GROUPADMIN') {
            nextValidTab = tabsList[i].header;
            break;
        }
    }

    // If no valid tab found after, look before the closed tab
    if (!nextValidTab) {
        for (let i = closedIndex - 1; i >= 0; i--) {
            if (tabsList[i].header !== 'DASHBOARD' && tabsList[i].header !== 'GROUPADMIN') {
                nextValidTab = tabsList[i].header;
                break;
            }
        }
    }

    // Set the lastSelectedHeaderName to the next valid tab, defaulting to '' if none found. If 'Inbox' is given here, then the inbox tab gets created while closing. Which isn't ideal.
    this.lastSelectedHeaderName = nextValidTab || '';
    /** QMA-1320 **/

    if ((closedHeaderName.includes("NEW MESSAGE") || closedHeaderName.includes("DRAFT")) && event.originalEvent.isTrusted) {
      this.confirmationService.confirm({
        message: 'Do you want to <b class="bold-text">save</b> changes?',
        accept: () => {
          this.userDataService.userUsageStats("New Message", "Save Draft").subscribe(result => console.log("StartTime:" + new Date()));
          PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Menu", "New message - Save Draft", "Click", "New message -Save Draft", 0);
          this.performTabOperation(event, closedHeaderName);
          const closeTab = {
            draftFlag: true,
            id: closedHeaderName
          };
          this.tabDataService.saveDraftOnTabClose(closeTab);

         this.redirectCheck();
        },
        reject: () => {
          this.performTabOperation(event, closedHeaderName);
          this.userDataService.userUsageStats("Dashboard", "Dashboard").subscribe(result => console.log("StartTime:" + new Date()));

          this.redirectCheck();
        }
      });
    } else {
      this.performTabOperation(event, closedHeaderName);
      this.userDataService.userUsageStats("Dashboard", "Dashboard").subscribe(result => console.log("StartTime:" + new Date()));

      this.redirectCheck();
    }

    this.redirectCheck();
  }
  performTabOperation(event, closedHeaderName) {
    event.close();

    if (this.currentInquiries && this.currentInquiries.hasOwnProperty(closedHeaderName)) {
      delete this.currentInquiries[closedHeaderName];
    }

    const powerbiIndex = this.powerbiReportDetails.findIndex(p => p.key === closedHeaderName);
    if (powerbiIndex !== -1) {
      this.powerbiReportDetails.splice(powerbiIndex, 1);
    }

    this.items.splice(event.index, 1);
    // if last tab is closed without selecting any other tab
    if (this.selectedHeaderName == this.lastSelectedHeaderName &&
      this.selectedHeaderName == closedHeaderName) {
      this.selectedHeaderName = this.tabs.tabs[event.index > 0 ? event.index - 1 : 0].header;

      this.lastSelectedHeaderName = this.selectedHeaderName;
      this.tabs.tabs[0].selected = false;
    }
    // if closed tab name = selected tab, keep the last selected tab as selected
    else if (closedHeaderName == this.selectedHeaderName) {
      this.selectedHeaderName = this.lastSelectedHeaderName;
      if (!this.selectedHeaderName) {
        this.selectedHeaderName = this.tabs.tabs[event.index > 0 ? event.index - 1 : 0].header;
      }
      this.tabs.tabs[0].selected = false;
      // default selected tab, then close any other tab
    } else {
      if (this.selectedTabIndex !== -1 && this.tabs.tabs[this.selectedTabIndex]) {
        const header = this.tabs.tabs[this.selectedTabIndex].header;
        this.lastSelectedHeaderName = this.selectedHeaderName;
        this.selectedHeaderName = this.tabs.tabs[this.selectedTabIndex].header;
      }
      // reset selected state
      this.tabs.tabs[0].selected = false;
    }

    this.selectedTabIndex = this.getIndex(this.items, this.selectedHeaderName);

    if (this.selectedTabIndex !== -1) {
      //Find the index of selected header name and selected that specific tab as on close tabs object still remain same until removed.
      let tabIndex = this.tabs.tabs.findIndex(tab => tab.header == this.selectedHeaderName);
      this.tabs.tabs[tabIndex].selected = true;
    }
    // Clear the search criteria on tab close except new message
    if (this.userDataService.loggedInUserInfo.taskizeConfig && this.userDataService.loggedInUserInfo.taskizeConfig.taskizeEnabled && this.userDataService.loggedInUserInfo.isTaskizeEnabledForUser && this.userDataService.loggedInUserInfo.isTaskizeEnabledForUser?.toUpperCase() == 'Y') {
      if (!closedHeaderName.includes("NEW MESSAGE") || !closedHeaderName.includes(QmaConstant.QMA_NEW_BUBBLE)) {
        this.searchClr.emit(true);
      }
    } else {
      if (!closedHeaderName.includes("NEW MESSAGE")) {
        this.searchClr.emit(true);
      }
    }


    if (this.selectedTabIndex !== -1 && this.isMobile) {
      this.tabDataService.sendTabData(this.items[this.selectedTabIndex].text, this.items[this.selectedTabIndex].value, 'leftnav');
    } else {
      sessionStorage.setItem("currentTab", this.selectedHeaderName); // on close of a tab, got to update session storage

      // For fixing the bug when drafts or new messages were closed and it affected the position of drawer icon
      let currentTab = sessionStorage.getItem("currentTab");
      if(!this.isInboxOrNewMessage(currentTab)) {
        this.tabDataService.sendTabData(currentTab, 0);
      }
      this.inboxService.triggerSearchTabEvent({ action: 'close', tab: closedHeaderName });
    }
    let inqId: number;
    const currIdArr = closedHeaderName.match(/\d+/g);
    if (currIdArr) {
      inqId = currIdArr[0];
      let map = this.tabDataService.clcData;
      map.forEach((v, k, map) => {
        if (k === inqId) map.delete(k);
      });
    }

    // If the close tab is personal mail box, we need to clear the selected item.
    if (closedHeaderName.includes(QmaConstant.QMA_PERSONAL)) {
      this.personalEmailService.setSelectedFolder(null);
    }
  }

  setHeader() {
    if (this.inMobileSearch) {
      return 'mobileSearchTabHeader';
    } else if (this.items.length == 1) {
      return 'hide-tab-header';
    } else {
      return 'tabHeader';
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.unreadSubscription.unsubscribe();

    if (this.dashboardCountSubs$) {
      this.dashboardCountSubs$.unsubscribe();
    }

    if (this.tabDataDrawerSubscription) {
      this.tabDataDrawerSubscription.unsubscribe();
    }
  }
  /**
   * Method to decide tab should contain Inbox or New Message Component.
   */
  isInboxOrNewMessage(tabText: string): boolean {
    let isAllowed: boolean = false;
    const tabDetail = TabsComponent.NEW_MESSAGE_COMPONENTS.find(tabName => tabText.includes(tabName));
    const matchingItem = this.items.find(i => i.text === tabText);
    const triggeredFromTags = matchingItem && matchingItem.inputData && matchingItem.inputData === "triggeredFromTag" ? true : false;
    isAllowed = tabDetail && !triggeredFromTags ? true : false;
    return isAllowed;
  }

  /**
   * Method to decide to show count or not
   */
  showCount(tabText: string): boolean {
    let isAllowed: boolean = false;
    let tabDetail = TabsComponent.TAB_TEXT.find(tabName => tabText.includes(tabName));
    isAllowed = tabDetail ? true : false;
    return isAllowed;
  }
  displayEllipsis(_count: number) {
    if (_count >= 1000) {
      return ((_count / 1000).toFixed(1) + "k");
    }
    else {
      return _count;
    }
  }
  /**
   * Handle keyboard events
   */
  @HostListener('document:keydown.alt.s', ['$event'])
  onKeyDown(event) {
    event.stopPropagation();
    event.preventDefault();
    if (event && event.altKey && !event.ctrlKey && !event.shiftKey && !event.metaKey) {
      if (event.key === 's') {
        this.tabDataService.triggerActionEvent({ action: 'Send', tabName: this.selectedHeaderName });
        // do not propagate further
        return false;
      }
    }
    return true;
  }

  /**
   * Handle row-drag dragover event
   */
  handleRowDragOver(event) {
    if (event && event.innerText) {
      const header = event.innerText;
      const currentIndex = this.getIndex(this.items, header, true);
      if (currentIndex !== -1 && currentIndex !== this.selectedTabIndex) {
        this.tabs.tabs.forEach(tab => {
          tab.selected = false;
        });
        this.selectedTabIndex = currentIndex;
        this.tabs.tabs[this.selectedTabIndex].selected = true;
        this.lastSelectedHeaderName = this.selectedHeaderName;
        this.selectedHeaderName = header;
      }
    }
  }

  /**
   * Handle row-drag drag drop event
   */
  handleRowDragDrop(event: any) {
    if (event && event.innerText && event.data) {
      const header = event.innerText;
      const currentIndex = this.getIndex(this.items, header, true);
      if (currentIndex !== -1 && currentIndex !== this.selectedTabIndex) {
        this.tabs.tabs.forEach(tab => {
          tab.selected = false;
        });
        this.selectedTabIndex = currentIndex;
        this.tabs.tabs[this.selectedTabIndex].selected = true;
        this.lastSelectedHeaderName = this.selectedHeaderName;
        this.selectedHeaderName = header;
      }
      this.inboxService.triggerRowDragDrop({ header: header, data: event.data });
      this.inboxService.triggerInquiryDrag({ qma: true, active: false });
    }
  }

  /**
   * Return whether this is an Inquiry Tab
   */
  isInquiry(tabText: string): boolean {
    return tabText && tabText.startsWith('INQUIRY:');
  }

  /**
   * Return whether the tabshould be highlighted for drag/drop
   */
  isDragDropHighlight(tabText: string): boolean {
    if (!this.borderHighlight || !tabText) {
      return false;
    }
    return TabsComponent.DRAGDROP_ENABLED.findIndex(tab => tabText.toUpperCase().indexOf(tab.toUpperCase()) !== -1) !== -1;
  }

  /**
   * C153176-4540: check whether a search covers more than one targeted boxes, in which case the SEARCH tab should be
   * used to display search result instead of one of the eligible tabs.
   */
  isMultiBoxMatched() {
    if (!this.inboxService.searchBoxes || !this.inboxService.searchBoxes.length) {
      return false;
    }
    return false; //C153176-5220:Design changed to select single Mailbox, so will always return false.
  }


  switchTab(item: any) {
    if (item.label == "New Message") {
      this.tabDataService.sendTabData('NEW MESSAGE', 0, 'leftNav');
    }
    else if (item.label == "Dashboard") {
      this.tabDataService.sendTabData(item.label.toUpperCase(), 0);
    } else {
      this.inboxService.checkBeforeLoad = true;
      this.tabDataService.sendTabData(item.label, item.count, 'leftNav');
      this.leftNavigationService.formRequestObjectOfGrid(item.label);
    }
  }

  isObjetEmpty(obj) {
    return Object.keys(obj).length === 0 ? true : false;

  }

  /**
  * Return whether this is an Inquiry Tab
  */
  isSymphonyChat(tabText: string): boolean {
    return tabText && tabText.startsWith('CHAT:');
  }
  onOutsideClick(){
      if(this.sidePanelOpen){
        this.closeSidePanel()
      }
  }

  /** function to format the tab text **/
  formatTabText(inputText: string): string {
    if (!inputText) {
      return '';
    }

    let mainText = inputText;
    let suffix = '';

    // find a number in square brackets at the end of the string
    const bracketEndRegex = /\[(\d+)\]$/;
    const bracketMatch = bracketEndRegex.exec(inputText);

    if (bracketMatch) {
      mainText = inputText.substring(0, bracketMatch.index);
      const numberInBrackets = bracketMatch[1];
      suffix = ` (${numberInBrackets})`;
    } else {
      // if no square brackets, check for existing parentheses
      const parenthesisEndRegex = /\s*\((\d+)\)$/;
      const parenthesisMatch = parenthesisEndRegex.exec(inputText);
      if (parenthesisMatch) {
        mainText = inputText.substring(0, parenthesisMatch.index);
        const numberInParentheses = parenthesisMatch[1];
        suffix = ` (${numberInParentheses})`;
      }
    }

    // check if the mainText part is capitalized, and not empty
    const isAllUpperCase =
      mainText.length > 1 &&
      mainText === mainText.toUpperCase() &&
      /[A-Z]/.test(mainText) &&
      mainText !== mainText.toLowerCase();

    let formattedMainText = mainText;
    if (isAllUpperCase) {
      // convert to Title Case
      formattedMainText = mainText
        .toLowerCase()
        .split(' ')
        .map(word => {
          if (word.length === 0) {
            return '';
          }
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    }

    return formattedMainText + suffix;
  }
  trackByText(_index: number, item: TextValueLabel): string {
    return item.text;
  }
  isValidReportType(item: string) {
    return this.inqReportTypes.includes(item)
      || QmaConstant.QMA_MIS_DASHBOARD_TYPES.includes(item)
      || this.powerbiReportDetails.some(p => p.key === item)
      || this.tabDataService.misReportTabNames.has(item);
  }
  /** True if this tab shows a Power BI report (from Report Criteria or deep link / link click). */
  isReportTab(item: { text: string; inputData?: any }): boolean {
    // Exclude Dashboard from report tab logic
    if (!item || typeof item.text !== 'string') return false;
    const text = item.text.trim().toUpperCase();
    if (text.includes('DASHBOARD')) return false;
    // 'Management Report' tab is rendered by app-mis-report via its own ngSwitchCase;
    // isValidReportType returns true for it (it's in QMA_REPORT_TYPES) which would cause
    // both app-powerbi-report AND app-mis-report to render simultaneously under [ngSwitch]="true".
    if (text === 'MANAGEMENT REPORT') return false;
    // Tabs opened from MIS button/hyperlink clicks carry reportConfig in inputData, or the name
    // is registered in misReportTabNames — treat as report regardless of powerbiReportDetails timing.
    if (item.inputData?.reportConfig?.id) return true;
    return this.isValidReportType(item.text) || this.powerbiReportDetails.some(p => p.key === item.text);
  }
  /** Report config for this tab (from powerbiReportDetails) or fallback to current reportConfig. */
  getReportConfigForItem(item: { text: string }): any {
    const stored = this.powerbiReportDetails.find(p => p.key === item.text)?.value;
    return stored ?? this.reportConfig;
  }
  /** Event handlers for this tab (from powerbiReportDetails), if any were stored (e.g. MIS drill-throughs). */
  getEventHandlersForItem(item: { text: string }): Map<string, (event?: any) => void> | null {
    return this.powerbiReportDetails.find(p => p.key === item.text)?.eventHandlers ?? null;
  }
  onReportConfigCreated(config: any) {
    // Now you can use this config in your parent
    this.reportConfig = config;
    this.powerbiReportDetails.push({ key: this.selectedReportType, value: this.reportConfig });
  }
  reportTypeSelected(reportType: string) {
    this.selectedReportType=  reportType;
  }
  get coreComponent(): CoreComponent {
    return this.injector.get(CoreComponent);
  }
}